const SectionHowTo = Class(
    /**
     * @lends {SectionHowTo#}
     */
    {
        __NAME: 'SectionHowTo',

        background: null,
        bodyClass: 'small-nav',
        menuItem: 'how',

        draw: function() {
            let heroUrl = {
                tag: 'a',
                href: D.url(D.Lang.get('how-to.welcome.button.link')),
                className: 'button button-large button-pink',
                text: D.Lang.get('how-to.welcome.button')
            };
            if (D.Lang.get('how-to.welcome.button.link') === 'contact-us') {
                delete heroUrl.href;
                heroUrl.onclick = function() {
                    D.scrollIntoView(document.querySelector('.how-to-contacts'));
                };
            }

            new T.Hero({
                backgroundClass: `background-picture-how-to`,
                backgroundOverlay: true,
                backgroundArrow: true,
                backgroundMask: 'white',
                title: D.Lang.get('how-to.welcome.title'),
                text: D.Lang.get('how-to.welcome.text'),
                button: mkE(heroUrl)
            }).append(this.layout.ct());

            mkE({
                tag: 'div',
                className: 'game-flow-wrapper',
                els: [
                    new T.GameFlow()
                ]
            }).append(this.layout.ct());

            mkE({
                tag: 'div',
                className: 'easy-access-wrapper how-to-easy-access-wrapper',
                els: [
                    new T.EasyAccess()
                ]
            }).append(this.layout.ct());

            mkE({
                tag: 'div',
                className: 'how-to-wrapper',
                els: [
                    this._howTo = new T.HowTo([
                        'matchmaker',
                        'g-spot',
                        'explorer',
                        'sprinter',
                        'hunter',
                        'groupie',
                        'expert',
                        'detective',
                        'coder',
                        'golddigger'
                    ], 'matchmaker')
                ]
            }).append(this.layout.ct());

            if (D.LANG === 'en') {
                mkE({
                    tag: 'div',
                    className: 'corporate-form-wrapper',
                    els: [
                        new T.CorporateContactUs()
                    ]
                }).append(this.layout.ct());
            } else {
                new T.FooterRegister().append(this.layout.ct());
            }

            this.ready();
        },

        onShow() {
            if (this._howTo) {
                this._howTo.onShow();
            }
        },

        onLeave() {
            if (this._howTo) {
                this._howTo.onLeave();
            }
        }
    },
    Section
);